module.exports = __webpack_public_path__ + "static/img/dashboard_logo_left.d8cc173.svg";


//////////////////
// WEBPACK FOOTER
// ./static/prism/images/dashboard_logo_left.svg
// module id = 4XiZ
// module chunks = 73